import { ReactNode } from 'react';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';

const containerStyle = {
  gap: 'padding_16',
  '@media (max-width: 1280px)': {
    gap: 'padding_12',
  },
  '@media (max-width: 1024px)': {
    gap: 'padding_8',
  },
};

type SectionWrapperProps = {
  children: ReactNode;
  sx?: Record<string, unknown>;
};

const SectionWrapper = ({ children, sx }: SectionWrapperProps) => {
  return <FlexColumn sx={{ ...containerStyle, ...sx }}>{children}</FlexColumn>;
};

export default SectionWrapper;
